export default __webpack_public_path__ + "static/media/26.fb1caa94.jpg";